import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

import DocumentListItem from './DocumentListItem.vue'
import DocumentViewer from '@/components/DocumentViewer.vue'
import PictureViewer from '@/components/PictureViewer.vue'
import { Document } from '@/types/document'
import { DocumentType } from '@/utils/enums'
import { isPDF, formatFileName } from '@/utils/utility-manager'

export interface DocumentManagerListProps {
  documents: Document[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentList',
  props: {
    documents: null
  },
  emits: ["unlink"],
  setup(__props: any) {

const props = __props as {
  documents: Document[]
};




const imageUrls = computed(() => {
  return props.documents.filter((doc) => doc.url).map((doc) => doc.url!)
})

const imageIndex = ref(0)
const documentViewer = ref()
const documentUrl = ref('')
const documentTitle = ref('')
const showLightBox = ref(false)

function onClick(doc: any): void {
  if (doc.type === DocumentType.FILE && isPDF(doc.url)) {
    toggleDocumentViewer(doc.url, formatFileName(doc.originName))
  } else if (doc.type === DocumentType.FILE && !isPDF(doc.url)) {
    togglePictureViewer(doc.url)
  }
}

function toggleDocumentViewer(newUrl: string, newTitle?: string) {
  documentTitle.value = newTitle || ''
  documentUrl.value = newUrl
  const viewer = documentViewer.value as DocumentViewer
  viewer.toggleDialog()
}

function togglePictureViewer(newUrl: string) {
  imageIndex.value = imageUrls.value.findIndex((url) => url === newUrl)
  showLightBox.value = true
}

return { __sfc: true,props, imageUrls, imageIndex, documentViewer, documentUrl, documentTitle, showLightBox, onClick, toggleDocumentViewer, togglePictureViewer, DocumentListItem, DocumentViewer, PictureViewer }
}

})